import React, { ReactElement } from 'react';
import BadgeInternal from '@mui/material/Badge';
import TextBlock from '../text-block/text-block.component';
import FormatService from '../../services/format-service';
import useStylesBadge from './badge.styles';

const Badge: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const COLOR_SECONDARY: ThemeColor = 'secondary';

  const {
    isCompact,
    content,
    className,
    children,
  } = props;

  const { classes } = useStylesBadge();

  const compactClassName: string | undefined = isCompact ? classes.badgeCompact : undefined;

  return (
    <BadgeInternal
      color={COLOR_SECONDARY}
      classes={{
        badge: FormatService.formatClassNames(classes.badge, compactClassName, className),
      }}
      badgeContent={(
        <TextBlock>
          {content}
        </TextBlock>
      )}
    >
      {children}
    </BadgeInternal>
  );
});

export default Badge;
